import { render, staticRenderFns } from "./main_Foot.vue?vue&type=template&id=45ccbde3&scoped=true"
import script from "./main_Foot.vue?vue&type=script&lang=js"
export * from "./main_Foot.vue?vue&type=script&lang=js"
import style0 from "./main_Foot.vue?vue&type=style&index=0&id=45ccbde3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ccbde3",
  null
  
)

export default component.exports